import { render } from "./Main.vue?vue&type=template&id=4866b7e0&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=4866b7e0&scoped=true&lang=css"
import "./Main.vue?vue&type=style&index=1&id=4866b7e0&lang=css"

import exportComponent from "/codebuild/output/src1910356388/src/ilongevity-backoffice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4866b7e0"]])

export default __exports__